import {
    CLEAR_POU_PCELARSTVO_CONTROL,
    CREATE_NEW_POU_PCELARSTVO_CONTROL,
    CREATE_POU_PCELARSTVO_CONTROL,
    DELETE_POU_PCELARSTVO_CONTROL,
    FETCH_POU_PCELARSTVO_CONTROL,
    UPDATE_POU_PCELARSTVO_CONTROL
} from "../actionTypes";

const initialState = {
    pouPcelarstvoControl: null
};

export function pouPcelarstvoControlReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_POU_PCELARSTVO_CONTROL: {
            return {
                ...state,
                pouPcelarstvoControl: action.payload
            };
        }
        case UPDATE_POU_PCELARSTVO_CONTROL: {
            return {
                ...state,
                pouPcelarstvoControl: action.payload
            };
        }
        case CREATE_NEW_POU_PCELARSTVO_CONTROL: {
            return {
                ...state,
                pouPcelarstvoControl: action.payload
            };
        }
        case CREATE_POU_PCELARSTVO_CONTROL: {
            return {
                ...state,
                pouPcelarstvoControl: action.payload
            };
        }
        case DELETE_POU_PCELARSTVO_CONTROL: {
            return {
                ...state,
                pouPcelarstvoControl: action.payload
            };
        }
        case CLEAR_POU_PCELARSTVO_CONTROL: {
            return {
                ...state,
                pouPcelarstvoControl: null
            };
        }
        default:
            return state;
    }
}

export const getPouPcelarstvoControl = state => state.pouPcelarstvoControl.pouPcelarstvoControl;